import Commons from '../../../../Services/Common/Common';
import dayjs from 'dayjs';

export const M_FILE_CUSTOM_03_Schema = {
  mapper: {
    search1: {
      UserId: (context) => context.userInfo?.userid,
    },
    search2: {
      UserId: (context) => context.userInfo?.userid,
      CustCd: (context) => Commons.EncryptAES(context.userInfo?.custCd || ''),
      WorkDate: (context) => Commons.EncryptAES(dayjs().format('YYYY-MM-DD')),
      DepCd: (context) => Commons.EncryptAES(context.depCd || ''),
      Status: (context) => Commons.EncryptAES(''),
    },
    search3: {
      PmCd: (context) => Commons.EncryptAES(context?.pmCd ?? ''),
      WorkDate: (context) => Commons.EncryptAES(dayjs().format('YYYY-MM-DD')),
      UserId: (context) => context.userInfo?.userid,
    },
  },
};
